export default "__VITE_ASSET__f6573a35__"